export function formatQuestionSequence(sequence: number) {
  return String(Math.max(1, sequence)).padStart(2, '0');
}

export function resolveQuestionDisplayId(
  questionTypeCode: string,
  legacyQuestionId?: string | null,
  legacyQIdx?: number | null,
  fallbackSequence?: number | null,
) {
  const normalizedLegacyId = String(legacyQuestionId || '').trim();
  if (normalizedLegacyId) {
    return normalizedLegacyId;
  }
  if (typeof fallbackSequence === 'number' && Number.isFinite(fallbackSequence) && fallbackSequence > 0) {
    return `${questionTypeCode}-${String(Math.floor(fallbackSequence)).padStart(3, '0')}`;
  }
  if (typeof legacyQIdx === 'number' && Number.isFinite(legacyQIdx)) {
    return `${questionTypeCode}-${String(legacyQIdx).padStart(3, '0')}`;
  }
  return questionTypeCode;
}

export type QuestionTitleDisplayMode = 'title' | 'display_id' | 'sequence_and_display_id';

export function resolveQuestionTitle(
  params: {
    mode?: QuestionTitleDisplayMode | string | null;
    title?: string | null;
    questionTypeCode: string;
    legacyQuestionId?: string | null;
    legacyQIdx?: number | null;
    sequence?: number | null;
  },
) {
  const {
    mode,
    title,
    questionTypeCode,
    legacyQuestionId,
    legacyQIdx,
    sequence,
  } = params;
  const displayId = resolveQuestionDisplayId(questionTypeCode, legacyQuestionId, legacyQIdx, sequence);
  if (mode === 'display_id') {
    return displayId;
  }
  if (mode === 'sequence_and_display_id') {
    const sequenceLabel = typeof sequence === 'number' && Number.isFinite(sequence)
      ? `Question ${formatQuestionSequence(sequence)}`
      : 'Question';
    return `${sequenceLabel} · ${displayId}`;
  }
  return String(title || '').trim() || displayId;
}

export function shouldShowQuestionDisplayIdMeta(mode?: QuestionTitleDisplayMode | string | null) {
  return !mode || mode === 'title';
}
